import config from 'config';

export const isProduction = config.ENV === 'prod';
export const isStaging = config.ENV === 'qa';
export const isDevelopment = config.ENV === 'proto';
export const isLocal = config.ENV === 'dev';

export const throwOrLog = (errorMessage: string) => {
  if (isProduction) {
    console.error(errorMessage);
  } else {
    throw new Error(errorMessage);
  }
};
